// extracted by mini-css-extract-plugin
module.exports = {"root":"Logo_root__3ZTth","image":"Logo_image__2wqoL","text":"Logo_text__2fTDv"};